export default "__VITE_ASSET__380ed1a9__"